/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography } from "@mui/material";
import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import StyledEditBusinessOverview from "./StyledEditBusinessOverview";
import { Controller, useForm } from "react-hook-form";
import { step3Schema } from "../../schema/signupSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { INPUT_LABELS } from "../../constants/lang";
import TextFeild from "../../components/CommonComponents/TextFeild";
import { fetchEditSellerProfile } from "../../store/reducers/createProfile";
import { ToastNotifyError, ToastNotifySuccess } from "../../components/CommonComponents/Toast/ToastNotify";
import { useDispatch } from "react-redux";
import rollbar from "../../rollbarConfig";

const EditConnectSocials = forwardRef(function EditConnectSocials(props, ref, getData) {
    const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm({
    resolver: yupResolver(step3Schema),
  });

  const onSubmit = async(data) => {
    const dataToSend = {
      instagram_link: data?.instagram,
      others_link: data?.other,
    }

    try {
        const res = await dispatch(fetchEditSellerProfile(dataToSend));
        const { status, message } = res?.payload || {};
        if (status) {
          getData?.()
          ToastNotifySuccess(message);
        } else {
          ToastNotifyError(message);
        }
    } catch (err) {
      rollbar.error("Error message", err);
      console.error(err);
    }
  };

  useEffect(() => {
    setValue('instagram', props?.userData?.instagram_link);
    setValue('other', props?.userData?.others_link);

  }, [props.userData])

  useImperativeHandle(ref, () => ({
    submit: () => {
      handleSubmit(onSubmit)();
    }
  }));

  return (
    <StyledEditBusinessOverview>
      <Box
        className='edit-business-overview-wrap'
        component='form'
        onSubmit={handleSubmit(onSubmit)}
      >
        <Typography className='edit-business-overview-header'>
          Connect your socials
        </Typography>
        <Box className='signup-textfeilds'>
          <Box className='signup-store'>
            <Box className='text-feilds'>
              <Controller
                name='instagram'
                control={control}
                defaultValue=''
                render={({ field }) => (
                  <TextFeild
                    {...field}
                    id='instagram'
                    label={INPUT_LABELS.instagram}
                    placeholder='Enter a valid Instagram Profile URL (https://)'
                    variant='outlined'
                    fullWidth
                    margin='normal'
                    error={!!errors.instagram}
                    helperText={errors.instagram?.message}
                  />
                )}
              />
            </Box>
            <Box className='text-feilds'>
              <Controller
                name='other'
                control={control}
                defaultValue=''
                render={({ field }) => (
                  <TextFeild
                    {...field}
                    id='other'
                    label={INPUT_LABELS.other}
                    placeholder='Enter your Other profile URL'
                    variant='outlined'
                    fullWidth
                    margin='normal'
                    error={!!errors.other}
                    helperText={errors.other?.message}
                  />
                )}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </StyledEditBusinessOverview>
  );
});

export default EditConnectSocials;
